import { MenuItem, SubMenu } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import isEmpty from 'lodash.isempty';
import React, { forwardRef } from 'react';
import { MenuItem as MenuItemType, ItemComponentType } from '../types';

export interface MenuItemWrapperProps {
    item: MenuItemType;
    onSelect: (value: string, parentValue?: string) => void;
    ItemComponent?: ItemComponentType;
    submenuProps?: Record<string, unknown>;
    menuItemProps?:Record<string, unknown>;

}

const DefaultItemComponent: ItemComponentType = ({ item }) => (
    <div>
        <span>{item.label}</span>
    </div>
);

export const MenuItemWrapper = forwardRef<HTMLDivElement, MenuItemWrapperProps>(
    ({ item, onSelect, ItemComponent = DefaultItemComponent , menuItemProps, ...submenuProps}, ref) => {
        const hasSubItems = !isEmpty(item.subItems);
        const currItemKey = `${item.parentValue || 'root'}-${item.value}`;

        if (hasSubItems) {
            return (
                <SubMenu ref={ref} key={currItemKey} label={<ItemComponent item={item} />} {...submenuProps}>
                    {item.subItems?.map((subItem: MenuItemType) => (
                        <MenuItemWrapper
                            key={`${item.value}-${subItem.value}`}
                            item={{ ...subItem, parentValue: item.value }}
                            onSelect={onSelect}
                            ItemComponent={ItemComponent}
                            menuItemProps={menuItemProps}
                            {...submenuProps}
                        />
                    ))}
                </SubMenu>
            );
        }
        return (
            <MenuItem
                ref={ref}
                key={currItemKey}
                value={item.value}
                onClick={() => {
                    onSelect(item.value, item.parentValue);
                }}
                {...menuItemProps}
                className={menuItemProps?.className || ''}
            >
                <ItemComponent item={item} />
            </MenuItem>
        );
    }
);
